// Website dark mode. Only social pages (feed, posts, reels, profiles, places) opt in: the booking
// flows carry hardcoded light colors in their own CSS files, so darkening them would mix themes.
const KEY = "rasu-theme";
export const DARK_ROUTE_PREFIXES = ["/feed", "/p/", "/reel/", "/u/", "/place/", "/explore"];

export function getThemePreference() {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === "dark" || saved === "light") return saved;
  } catch {}
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function setThemePreference(value) {
  try {
    localStorage.setItem(KEY, value);
  } catch {}
}

export function applyThemeForPath(pathname) {
  const allowed = DARK_ROUTE_PREFIXES.some((p) => pathname === p || pathname.startsWith(p));
  document.documentElement.classList.toggle("dark", allowed && getThemePreference() === "dark");
}
